import type { ScenariosRequest } from '@api/api/scenario';
import type { ActiveFilterOptions } from '@terminal/components/filters/Filters';
import type {
  FilterGroups,
  ScenarioFilterGroupKeys,
} from '@terminal/hooks/use-filter-actions/useFilterActions';

export interface ScenarioFallbackSnapshot {
  ASSET_FILTERS: ActiveFilterOptions[];
  COLUMN_FILTERS: ActiveFilterOptions[];
  SCENARIO_CONDITIONS: ActiveFilterOptions[];
  entityTags: string[];
}

export interface ScenarioFallbackInput {
  assetFilterOption: ActiveFilterOptions;
  conditionFilterOption: ActiveFilterOptions;
  entityTags: string[];
  requestBody: ScenariosRequest;
}

export type ScenarioFallbackState =
  | { status: 'pending' }
  | {
      status: 'applied';
      snapshot: ScenarioFallbackSnapshot;
      requestBody: ScenariosRequest;
    }
  | { status: 'dismissed' };

export const createScenarioFallbackSnapshot = ({
  filterGroups,
  entityTags,
}: {
  filterGroups: FilterGroups<ScenarioFilterGroupKeys>;
  entityTags: string[];
}): ScenarioFallbackSnapshot => ({
  ASSET_FILTERS: filterGroups.ASSET_FILTERS.activeFilterOptions,
  COLUMN_FILTERS: filterGroups.COLUMN_FILTERS.activeFilterOptions,
  SCENARIO_CONDITIONS: filterGroups.SCENARIO_CONDITIONS.activeFilterOptions,
  entityTags: [...entityTags].sort(),
});
